import { HttpHeaders, HttpResponseBase } from '@angular/common/http';

function getHttpHeaderValueWithName(headers: HttpHeaders, name: string): string | undefined {
  const headerKey = headers.keys().find((key) => key.toLowerCase() === name);
  return (headerKey && headers.get(headerKey)) || undefined;
}

export function hasStatusWithHeaderValue(
  response: HttpResponseBase,
  status: number,
  headerKey: string,
  headerValue: string,
) {
  const authHeaderValue = getHttpHeaderValueWithName(response.headers, headerKey);
  return response.status === status && authHeaderValue === headerValue;
}
